class GtmEvents {
    init() {
        $('.shareEvent').on('click', this.shareEvent);
        $('.gtmevent').on('click', this.generalEvent);
        $('.checkout-gtm').on('click', this.checkout);
    }

    generalEvent(event) {
        var $el = $(event.currentTarget);

        var gtmEvent = {
            'event': $el.data('event'),
            'ecommerce': {
                'promoClick': {
                    'promotions': [{
                        'id': $el.data('id'),
                        'name': $el.data('campaign'),
                        'creative': $el.data('type'),
                        'position': $el.data('position')
                    }]
                }
            }
        };

        window.dataLayer.push(gtmEvent);
    }

    shareEvent(event) {
        var $el = $(event.currentTarget);

        var gtmEvent = {
            'event': 'interaction.share',
            'events': {
                'category': $el.data('channel'),
                'action': $el.data('action')
            }
        };

        window.dataLayer.push(gtmEvent);
    }

    checkout(event) {
        if (typeof cartProducts === 'undefined') {
            var cartProducts = {};
        }
        var $el = $(event.currentTarget);
        var name = $el.data('input');

        var option;
        if ($el.data('step') === 1) {
            option = $('.gtmOption [name="' + name + '"]').find(':selected').val();
            if (typeof option === 'undefined') {
                option = $('.' + name).text();
            }
        } else {
            var $input = $('.gtmOption [name="' + name + '"]:checked');
            option = $('label[for="' + $input.attr('id') + '"]').text();
        }

        var gtmEvent = {
            'event': 'checkout',
            'ecommerce': {
                'checkout': {
                    'actionField': {
                        'step': $el.data('step'),
                        'option': option
                    },
                    'products': cartProducts
                }
            }
        };

        window.dataLayer.push(gtmEvent);
    }
}

$(document).ready(function () {
    let gtmEvents = new GtmEvents();
    gtmEvents.init();
});